var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSparkleIcon2Colors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 24.142L13.5263 18.49L8 15.9601L13.5263 13.3764L16 7.77832L18.5263 13.3764L24 15.9601L18.5263 18.49L16 24.142Z",
    fill: "#4644B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14286 11.0507L3.55263 7.28275L0 5.59615L3.55263 3.87366L5.14286 0.141602L6.76692 3.87366L10.2857 5.59615L6.76692 7.28275L5.14286 11.0507Z",
    fill: "#FF714D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkleIcon2Colors);
export default __webpack_public_path__ + "static/media/sparkle-icon2colors.e26afea8398cdd5e69c17a5dad18bb0f.svg";
export { ForwardRef as ReactComponent };